import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AppRoutes } from 'src/app/app.routes';
import { AuthAction } from './auth-action';
import { AuthRepo } from './auth.repo';
import { DeviceInfoService } from '../services/device-info.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private readonly AUTH_TOKEN_KEY: string = 'AUTH_TOKEN';
    onAuthChanged: Subject<AuthAction> = new Subject<AuthAction>();

    constructor(
        private authenticationRepo: AuthRepo,
        private router: Router,
        private deviceInfoService: DeviceInfoService
    ) { }

    getAuthorizationToken(): string | null {
        return localStorage.getItem(this.AUTH_TOKEN_KEY);
    }

    isLoggedIn(): boolean {
        return !!this.getAuthorizationToken();
    }

    login(code: string): Observable<unknown> {
        return forkJoin({
            deviceId: this.deviceInfoService.getDeviceId(),
            phoneNumber: this.deviceInfoService.getPhoneNumber()
        }).pipe(
            switchMap(({ deviceId, phoneNumber }) => {
                return this.authenticationRepo.login(code, deviceId, phoneNumber);
            }),
            tap((loginResult) => {
                this.setSession(loginResult.token);
                this.onAuthChanged.next(AuthAction.Login);
            }),
            map(() => undefined)
        );
    }

    logout(callServer: boolean = true) {
        if (callServer) {
            this.authenticationRepo.logout().subscribe();
        }

        localStorage.clear();
        this.onAuthChanged.next(AuthAction.Logout);
        this.router.navigate([AppRoutes.Start]);
    }

    private setSession(token: string): void {
        localStorage.setItem(this.AUTH_TOKEN_KEY, token);
    }
}
